import { render, staticRenderFns } from "./BadgeLabel.vue?vue&type=template&id=19c9fa9e&scoped=true&"
import script from "./BadgeLabel.vue?vue&type=script&lang=ts&"
export * from "./BadgeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeLabel.vue?vue&type=style&index=0&id=19c9fa9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9fa9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('19c9fa9e', component.options)
    } else {
      api.reload('19c9fa9e', component.options)
    }
    module.hot.accept("./BadgeLabel.vue?vue&type=template&id=19c9fa9e&scoped=true&", function () {
      api.rerender('19c9fa9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPathV2/BadgeLabel.vue"
export default component.exports